<script lang="ts">
  import type { Photo } from '@do/models';
  import { DirectusImage, Preset } from '@do/svelte-directus-images';

  export let title: string;
  export let image: Photo | null;
  export let classes = '';
  export let imgElement: HTMLImageElement | undefined = undefined;
</script>

<DirectusImage
  imageData="{image}"
  alt="{title}"
  imgClasses="w-full h-full object-cover rounded-xl aspect-square {classes}"
  attributes="{{
    draggable: false,
  }}"
  pictureSizes="{{
    default: '100vw',
    'min-768': '33vw',
    'min-1024': 'calc((100vw - 200px) / 3)',
    'min-1280': 'calc((100vw - 200px) / 4)',
  }}"
  presetKeys="{Preset.Thumbnail}"
  loading="lazy"
  bind:imgElement
  on:load
/>
